import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule, MatToolbarModule, MatMenuModule, MatButtonModule, 
  MatTableModule, MatDialogModule, MatProgressBarModule, MatFormFieldModule, 
  MatAutocompleteModule, MatRadioModule, MatSelectModule, MatIconModule, 
  MatTooltipModule, MatSnackBarModule, MatBadgeModule, MatTabsModule, 
  MatCardModule, MatProgressSpinnerModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatTableModule,
    MatDialogModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatTabsModule,
    MatCardModule,
    MatProgressSpinnerModule
  ],
  exports: [
    MatInputModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatTableModule,
    MatDialogModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatTabsModule,
    MatCardModule,
    MatProgressSpinnerModule
  ],
  declarations: []
})
export class MaterialModule { }
